import { fromJS } from 'immutable';
const action = name => `/test/${name}`;

//get plan 
export const GET_PLAN = action('GET_PLAN');
export const GET_PLAN_SUCCESS = action('GET_PLAN_SUCCESS');
export const GET_PLAN_ERROR = action('GET_PLAN_ERROR');

export const getPlan = data => ({ type: GET_PLAN, data });
export const getPlanSuccess = data => ({ type: GET_PLAN_SUCCESS, data });
export const errorInGatPlan = data => ({ type: GET_PLAN_ERROR, data });

//create card for user
export const CREATE_CARD = action('CREATE_CARD');
export const CREATE_CARD_SUCCESS = action('CREATE_CARD_SUCCESS');
export const CREATE_CARD_ERROR = action('CREATE_CARD_ERROR');

export const createUserCard = data => ({ type: CREATE_CARD, data });
export const createCardSuccess = data => ({ type: CREATE_CARD_SUCCESS, data });
export const errorInCreateCard = data => ({ type: CREATE_CARD_ERROR, data });

//createSubscription
export const CREATE_SUBSCRIPTION = action('CREATE_SUBSCRIPTION');
export const CREATE_SUBSCRIPTION_SUCCESS = action('CREATE_SUBSCRIPTION_SUCCESS');
export const CREATE_SUBSCRIPTION_ERROR = action('CREATE_SUBSCRIPTION_ERROR');

export const createSubscription = data => ({ type: CREATE_SUBSCRIPTION, data });
export const createSubscriptionSuccess = data => ({ type: CREATE_SUBSCRIPTION_SUCCESS, data });
export const errorInCreateSubscription = data => ({ type: CREATE_SUBSCRIPTION_ERROR, data });

//get user billing
export const GET_BILL = action('GET_BILL');
export const GET_BILL_SUCCESS = action('GET_BILL_SUCCESS');
export const GET_BILL_ERROR = action('GET_BILL_ERROR');

export const getUserBill = data => ({ type: GET_BILL, data });
export const getBillSuccess = data => ({ type: GET_BILL_SUCCESS, data });
export const errorInGatBill = data => ({ type: GET_BILL_ERROR, data });

//delete user card
export const DELETE_CARD = action('DELETE_CARD');
export const DELETE_CARD_SUCCESS = action('DELETE_CARD_SUCCESS');
export const DELETE_CARD_ERROR = action('DELETE_CARD_ERROR');

export const deleteUserCard = data => ({ type: DELETE_CARD, data });
export const deleteCardSuccess = data => ({ type: DELETE_CARD_SUCCESS, data });
export const errorInDeleteCard = data => ({ type: DELETE_CARD_ERROR, data });

// downloadInvoice
export const DOWNLOAD_INVOICE = action('DOWNLOAD_INVOICE');
export const DOWNLOAD_INVOICE_ERROR = action('DOWNLOAD_INVOICE_ERROR');

export const downloadInvoice = data => ({ type: DOWNLOAD_INVOICE, data });
export const downloadInvoiceError = data => ({ type: DOWNLOAD_INVOICE_ERROR, data });

// update primary card
export const UPD_PRIMARY = action('UPD_PRIMARY');
export const UPD_PRIMARY_ERROR = action('UPD_PRIMARY_ERROR');

export const updPrimary = data => ({ type: UPD_PRIMARY, data });
export const updPrimaryError = data => ({ type: UPD_PRIMARY_ERROR, data });

//cancel shopify Subscription
export const GET_DUE_AMOUNT = action('GET_DUE_AMOUNT');
export const GET_DUE_AMOUNT_SUCCESS = action('GET_DUE_AMOUNT_SUCCESS');
export const GET_DUE_AMOUNT_ERROR = action('GET_DUE_AMOUNT_ERROR');

export const getDueAmount = data => ({ type: GET_DUE_AMOUNT, data });
export const getDueAmountSuccess = data => ({ type: GET_DUE_AMOUNT_SUCCESS, data });
export const errorIngetDueAmount = data => ({ type: GET_DUE_AMOUNT_ERROR, data });

//upgradeSubscription
export const UPGRADE_SUBSCRIPTION = action('UPGRADE_SUBSCRIPTION');
export const UPGRADE_SUBSCRIPTION_SUCCESS = action('UPGRADE_SUBSCRIPTION_SUCCESS');
export const UPGRADE_SUBSCRIPTION_ERROR = action('UPGRADE_SUBSCRIPTION_ERROR');

export const upgradeSubscription = data => ({ type: UPGRADE_SUBSCRIPTION, data });
export const upgradeSubscriptionSuccess = data => ({ type: UPGRADE_SUBSCRIPTION_SUCCESS, data });
export const errorInUpgradeSubscription = data => ({ type: UPGRADE_SUBSCRIPTION_ERROR, data });

//cancelSubscription
export const CANCEL_SUBSCRIPTION = action('CANCEL_SUBSCRIPTION');
export const CANCEL_SUBSCRIPTION_SUCCESS = action('CANCEL_SUBSCRIPTION_SUCCESS');
export const CANCEL_SUBSCRIPTION_ERROR = action('CANCEL_SUBSCRIPTION_ERROR');

export const cancelSubscription = data => ({ type: CANCEL_SUBSCRIPTION, data });
export const cancelSubscriptionSuccess = data => ({ type: CANCEL_SUBSCRIPTION_SUCCESS, data });
export const errorInCancelSubscription = data => ({ type: CANCEL_SUBSCRIPTION_ERROR, data });

const initialState = fromJS({

});

const billing = (state = initialState, action) => {
  switch (action.type) {
    //get plan
    case GET_PLAN_SUCCESS:
      return state.set('lstPlan', action.data);
    case GET_PLAN_ERROR:
      return state = action.data;

    //create user card 
    case CREATE_CARD_SUCCESS:
      return state.set('newCard', action.data);
    case CREATE_CARD_ERROR:
      return state.set('newCard', action.data);

    //createSubscription
    case CREATE_SUBSCRIPTION_SUCCESS:
      return state.set('crtSub', action.data);
    case CREATE_SUBSCRIPTION_ERROR:
      return state = action.data;

    //get user bill
    case GET_BILL_SUCCESS:
      return state.set('lstBill', action.data);
    case GET_BILL_ERROR:
      return state = action.data;

    //dueAmount
    case GET_DUE_AMOUNT_SUCCESS:
      return state.set('dueAmount', action.data);
    case GET_DUE_AMOUNT_ERROR:
      return state = action.data;

    //upgradeSubscription
    case UPGRADE_SUBSCRIPTION_SUCCESS:
      return state.set('updSub', action.data);
    case UPGRADE_SUBSCRIPTION_ERROR:
      return state = action.data;

    //cancelSubscription
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return state.set('cnlSub', action.data);
    case CANCEL_SUBSCRIPTION_ERROR:
      return state = action.data;

    default:
      return state;
  }
};

export default billing;


// WEBPACK FOOTER //
// ./src/ducks/billing.js